module.exports = __webpack_public_path__ + "img/2st.e3ff84e.png";